import { UserApi, UserRequestTableDto } from "generated/apiUsers";
import { Configuration } from "generated/configuration";
import { getLoggedinUser } from "helpers/api_helper";

const { REACT_APP_API_URL } = process.env;

export const fetchUserInfo = {
  queryFn: async () => {
    const authUser: any = getLoggedinUser();

    const api = new UserApi(
      new Configuration({
        accessToken: authUser.accessToken || "",
        basePath: `${REACT_APP_API_URL}`,
      })
    );

    const response = await api.userControllerGetUser(authUser.uid);
    console.log(response.data);
    return response.data;
  },
  queryKey: () => ["fetchUserInfo"],
};

export const fetchUsers = {
  queryFn: async (data: UserRequestTableDto) => {
    const authUser: any = getLoggedinUser();

    const api = new UserApi(
      new Configuration({
        accessToken: authUser.accessToken || "",
        basePath: `${REACT_APP_API_URL}`,
      })
    );


    const response = await api.userControllerFind(data);
    return response.data;
  },
  queryKey: (data?: any) => ["fetchUsers", { ...data }],
};

export const fetchUser = {
  queryFn: async (id: string) => {
    const authUser: any = getLoggedinUser();

    const api = new UserApi(
      new Configuration({
        accessToken: authUser.accessToken || "",
        basePath: `${REACT_APP_API_URL}`,
      })
    );

    const response = await api.userControllerGetUser(id);
    return response.data;
  },
  queryKey: (data?: any) => ["fetchUser", { ...data }],
};

export const exportUsers = {
  queryFn: async (data: UserRequestTableDto) => {
    const authUser: any = getLoggedinUser();

    const api = new UserApi(
      new Configuration({
        accessToken: authUser.accessToken || "",
        basePath: `${REACT_APP_API_URL}`,
      })
    );

    const response = await api.userControllerExport(data);
    return response.data;
  },
  queryKey: (data?: any) => ["exportUsers", { ...data }],
};
